import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["expandable", "variant", "isExpanded"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsxs as n, jsx as r } from "react/jsx-runtime";
import { FareCardBase as m, FareCardBaseContent as d } from "../FareCardBase.js";
import e from "react-loading-skeleton";
import { FareCardHeader as p } from "../FareCardHeader/FareCardHeader.js";
import { FareCardFooter as c } from "../FareCardFooter/FareCardFooter.js";
import { FareInfographicSkeleton as f } from "../../FareInfographic/FareInfographicSkeleton.js";
const k = _ref => {
  let {
      expandable: o,
      variant: t,
      isExpanded: a
    } = _ref,
    i = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */n(m, _objectSpread(_objectSpread({}, i), {}, {
    trackingName: "",
    children: [/* @__PURE__ */r(p, {
      title: /* @__PURE__ */r(e, {
        count: 1,
        width: "150px"
      }),
      children: /* @__PURE__ */r(e, {
        count: 1,
        width: "150px"
      })
    }), /* @__PURE__ */r(d, {
      children: /* @__PURE__ */r(f, {
        isExpanded: a,
        expandable: o,
        variant: t
      })
    }), /* @__PURE__ */r(c, {})]
  }));
};
export { k as FareCardSkeleton };